import type { Language, Translation } from '@dec/shared';

export interface CatalogValueEditable extends CatalogValue {
  translations: Array<CatalogValueTranslation>;
}

export interface CatalogValue {
  id?: string;
  catalogId?: string;
  code?: string;
  name?: string;
  parentId?: string;
  additionalFields: Record<string, number | Date | string | boolean>;
}
export interface CatalogValueTranslation {
  language: string;
  value: string;
}

export interface CatalogValueTranslation {
  language: string;
  value: string;
}
export interface CatalogParentSelection {
  id?: string;
}
export const resolveCatalogParentId = (
  parent: CatalogParentSelection | null | undefined,
  defaultParentId?: string
): string | null | undefined => (parent === null ? null : (parent?.id ?? defaultParentId));
export const prepareCatalogValueSubmit = (
  values: Record<string, any>,
  definitions: Array<{ field: string }>,
  defaultForm: CatalogValueEditable,
  catalogId?: string
) => {
  const { catalogType, ...payload } = values;
  payload.additionalFields = Object.fromEntries(
    definitions.map(({ field }) => [field, values[field]])
  );
  for (const { field } of definitions) delete payload[field];

  const selection = values.parent;
  payload.parentId = selection === null ? null : (selection?.id ?? defaultForm.parentId);
  delete payload.parent;
  if (payload.parentId === undefined) delete payload.parentId;

  payload.catalogId = catalogId ?? catalogType;
  if (payload.catalogId === undefined) delete payload.catalogId;

  return payload;
}; /* --- STATE --- */

export interface CatalogState {
  form?: CatalogValueEditable;
  showForm?: boolean;
  language?: Language;
  keyName?: string;
}
export type CatalogModel = CatalogValue;
export interface SearchCatalog {
  name?: string;
}
export type ContainerState = CatalogState;
export interface CatalogTypeModel {
  id?: string;
  description?: string;
  parentId?: string | null;
  isPrivate?: boolean;
  parent?: any;
  definitions?: Array<ColDefinitionModel>;
  translations?: Array<Translation>;
}
export interface ColDefinitionModel {
  field: string;
  label: string;
  type: 'text' | 'bool' | 'date' | 'number';
  translatable: boolean;
}

export const catalogName = {
  accountType: 'account-type',
  transactionType: 'transaction-type',
  personTypes: 'person-types',
  countries: 'countries',
  politicalDivisions: 'political-divisions',
  periodicityType: 'periodicity-types',
  rateType: 'rate-types',
  formCellSections: 'form-cell-sections',
  inboxTypes: 'inbox-types',
  inboxTypesTaxOfficer: 'inbox-types-tax-officer',
  taxReturnCurrencies: 'taxreturn-currencies',
  paymentMethod: 'payment-method',
  taxCollector: 'tax-collector'
};
